import { useMutation, useQueryClient } from '@tanstack/react-query'
import { outreachApi, outreachMessagesQueryKey, outreachStatusQueryKey } from '../api'

export function useLaunchOutreachMutation(startupId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: () => outreachApi.launch(startupId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: outreachStatusQueryKey(startupId) })
      await queryClient.invalidateQueries({ queryKey: outreachMessagesQueryKey(startupId) })
    },
  })
}
